import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const Content = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 0;
`;

export const Title = styled.h1`
  margin-bottom: 4px;
`;

export const Subtitle = styled.p`
  font-size: 1.8em;
  margin-top: 4px;
`;

export const Image = styled.img`
  width: 180px;
`;

export const Footer = styled.div`
  margin-bottom: 32px;
`;
